/**
 * Error thrown by Auth0 service functions.
 * Contains an error code that maps to an i18n key in `authErrors.*`.
 */
export class Auth0ServiceError extends Error {
  /**
   * Error code that maps to an i18n key suffix (e.g. "invalidGrant" -> t("authErrors.invalidGrant"))
   */
  code: string;

  constructor(code: string) {
    super(code);
    this.name = "Auth0ServiceError";
    this.code = code;
  }
}
